import { render, staticRenderFns } from "./demandLists.vue?vue&type=template&id=2ec62650&scoped=true&"
import script from "./demandLists.vue?vue&type=script&lang=js&"
export * from "./demandLists.vue?vue&type=script&lang=js&"
import style0 from "./demandLists.vue?vue&type=style&index=0&id=2ec62650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec62650",
  null
  
)

export default component.exports